import { DOC_TYPES } from "../lib/docTypes";

export const DocTypeSidebar = ({ docType, onSelect }) => (
  <aside className="w-full lg:w-80 shrink-0">
    <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3 px-1">
      1. Što vam treba?
    </p>
    <div className="flex flex-col gap-2">
      {DOC_TYPES.map((dt) => {
        const Icon = dt.icon;
        const active = docType === dt.id;
        return (
          <button
            key={dt.id}
            data-testid={`doctype-${dt.id}`}
            onClick={() => onSelect(dt.id)}
            className={`flex items-start gap-3 text-left rounded-2xl border p-4 transition-all duration-150 hover:-translate-y-0.5 ${
              active
                ? "bg-blue-50 border-blue-300 shadow-md shadow-blue-900/5"
                : "bg-white border-slate-200 hover:border-blue-200"
            }`}
          >
            <div
              className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
                active ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-500"
              }`}
            >
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <span className={`font-heading font-bold ${active ? "text-blue-700" : "text-slate-800"}`}>
                {dt.label}
              </span>
              <p className="text-xs text-slate-500 mt-0.5 leading-snug">{dt.short}</p>
            </div>
          </button>
        );
      })}
    </div>
  </aside>
);
